export default __webpack_public_path__ + "static/media/logo.42be5df0.png";